import BackgroundProfUpdate from '../components/ProfileUpdate/BackgrounProfUpdate';

export default function ProfileUpdation() {
    return (
        <div className="overflow-auto w-screen box-border h-screen">
            <BackgroundProfUpdate />
        </div>
    );
}
